import styled from '@emotion/styled'
import { css } from '@emotion/react'
import { Text as BaseText, Badge as BaseBadge } from '@leroy-merlin-br/backyard-react-ui'

const wrapperStyles = () => css`
  label: wrapper;

  display: flex;

  width: 100%;
`

const phoneDescriptionStyles = ({ theme }) => css`
  label: phone-description;

  margin-bottom: ${theme.spacings.bit};

  flex: 0 1 auto;
`

const phoneLinkStyles = () => css`
  label: phone-link;

  display: flex;
  align-items: center;
  justify-content: flex-start;
`

const phoneNumberStyles = ({ theme }) => css`
  label: phone-number;

  font-size: 10px;
  color: ${theme.colors.n900};
  font-weight: ${theme.font.weight.semibold};

  margin: 0 ${theme.spacings.bit} 0 ${theme.spacings.byte};

  &:hover {
    color: ${theme.colors.p700};
    text-decoration: underline;
  }

  ${theme.media.mega} {
    font-size: ${theme.typography.text.kilo.fontSize};
    line-height: ${theme.typography.text.kilo.lineHeight};
  }
`

const localeStyles = ({ theme }) => css`
  label: locale;

  font-size: 10px;
  color: ${theme.colors.n600};

  ${theme.media.mega} {
    font-size: ${theme.typography.text.kilo.fontSize};
    line-height: ${theme.typography.text.kilo.lineHeight};
  }
`

const badgeStyles = ({ theme }) => css`
  label: badge;

  margin-left: ${theme.spacings.bit};
`

const contactTypeStyles = ({ theme }) => css`
  label: contact-type;

  font-size: 11px;
  color: ${theme.colors.n900};

  ${theme.media.mega} {
    font-size: ${theme.typography.text.kilo.fontSize};
    line-height: ${theme.typography.text.kilo.lineHeight};
  }
`

export const Wrapper = styled('div')(wrapperStyles)
export const PhoneDescription = styled(BaseText)(phoneDescriptionStyles)
export const PhoneLink = styled('a')(phoneLinkStyles)
export const PhoneNumber = styled(BaseText)(phoneNumberStyles)
export const Locale = styled(BaseText)(localeStyles)
export const Badge = styled(BaseBadge)(badgeStyles)
export const ContactType = styled(BaseText)(contactTypeStyles)
